import Phaser from 'phaser';

const SVG_ASSETS = [
  ['sky', '/assets/environment/sky.svg'], ['cloud', '/assets/environment/cloud.svg'], ['hill', '/assets/environment/hill.svg'],
  ['spark', '/assets/effects/spark.svg']
] as const;

const PNG_ASSETS = [
  ['ground', '/assets/blocks/ground-block.png'], ['brick', '/assets/blocks/brick-block.png'],
  ['pipe-top', '/assets/blocks/pipe-top.png'], ['pipe-bottom', '/assets/blocks/pipe-bottom.png'],
  ['question-block', '/assets/blocks/mystery-block.png'], ['used-block', '/assets/blocks/empty-block.png'],
  ['coin', '/assets/items/mario-coin.png'], ['star', '/assets/items/mario-star.png'],
  ['licensed-cloud', '/assets/environment/mario-cloud.png'],
  ['castle', '/assets/environment/mario-castle.png'],
  ['hero-run-1', '/assets/characters/mario-run-1.png'], ['hero-run-2', '/assets/characters/mario-run-2.png'],
  ['hero-run-3', '/assets/characters/mario-run-3.png'], ['hero-jump', '/assets/characters/mario-jump.png'],
  ['koopa-walk-1', '/assets/characters/koopa-walk-1.png'], ['koopa-walk-2', '/assets/characters/koopa-walk-2.png'],
  ['goomba-walk-1', '/assets/characters/goomba-walk-1.png'], ['goomba-walk-2', '/assets/characters/goomba-walk-2.png']
] as const;

export class PreloadScene extends Phaser.Scene {
  constructor() { super('PreloadScene'); }
  preload(): void {
    this.cameras.main.setBackgroundColor('#172142');
    const title = this.add.text(195, 342, 'LEVEL WIRD GELADEN', { fontFamily: 'PixelFallback, monospace', fontSize: '19px', color: '#ffffff' }).setOrigin(0.5);
    const outline = this.add.rectangle(195, 390, 262, 22).setStrokeStyle(3, 0xffffff);
    const fill = this.add.rectangle(68, 390, 0, 14, 0xffd32a).setOrigin(0, 0.5);
    this.load.on('progress', (value: number) => fill.width = 254 * value);
    this.load.on('loaderror', () => title.setText('ASSET FEHLT – BITTE NEU LADEN'));
    SVG_ASSETS.forEach(([key, path]) => this.load.svg(key, path));
    PNG_ASSETS.forEach(([key, path]) => this.load.image(key, path));
    this.load.audio('coin', '/assets/audio/coin.wav');
    this.load.audio('jump', '/assets/audio/jump.wav');
    this.load.audio('hurry-up', '/assets/audio/hurry-up.wav');
    this.load.image('pixel-hills-sky', '/assets/environment/pixel-hills-sky.png');
  }
  create(): void {
    this.anims.create({ key: 'hero-run', frames: [{ key: 'hero-run-1' }, { key: 'hero-run-2' }, { key: 'hero-run-3' }, { key: 'hero-run-2' }], frameRate: 12, repeat: -1 });
    this.anims.create({ key: 'hero-jump', frames: [{ key: 'hero-jump' }], frameRate: 1 });
    this.anims.create({ key: 'koopa-walk', frames: [{ key: 'koopa-walk-1' }, { key: 'koopa-walk-2' }], frameRate: 7, repeat: -1 });
    this.anims.create({ key: 'goomba-walk', frames: [{ key: 'goomba-walk-1' }, { key: 'goomba-walk-2' }], frameRate: 7, repeat: -1 });
    this.scene.start('StartScene');
  }
}
